var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIFav(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.24 1.307l1.813 3.75a.544.544 0 00.409.3l4.074.605c.442.065.62.607.303.922L12.88 9.83a.543.543 0 00-.154.475l.697 4.148a.543.543 0 01-.792.568l-3.623-1.943a.545.545 0 00-.513 0L4.87 15.022a.543.543 0 01-.792-.57l.697-4.147a.543.543 0 00-.153-.475L1.661 6.884a.543.543 0 01.303-.922l4.074-.604a.544.544 0 00.41-.301l1.814-3.75a.543.543 0 01.977 0z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  })));
}
export default SvgIFav;